<!--  ---列表顶部筛选项---
传参形式：
filtList: [
  {
    id: 1,//每一个筛选项的id(必传且需要唯一)
    name: "行业类型",每一个筛选项的name
    connectionId: 3, //关联项的id（如果filtList id为3的项数据来源于当前选中的某个字段的值）
    connectionKey: "child", //被关联项的child的取值来源于当前选中项的字段的值
    checked: {//当前项选中的值
      id: 0,
      name: "全部"
    },
    keyProp: { id: "code" },//id--当前项id对应的值，name对应的取值（非必填，默认为id，name）
    child: []//对应的数据项
  },
  {
    id: 2,
    name: "行业分类",
    checked: {
      id: 0,
      name: "全部"
    },
    keyProp: { name: "industryClassificationName" },
    child: []
  },
],
回调函数：
1.filterchange//触发列表筛选的回调函数
2.selectTagItem//选中每一项筛选项的回调函数
3.clearAllFilter//清空所有筛选项的回调函数
4.filterMounted//当前组件已经挂在完成
-->
<template>
  <div class="filtrate">
    <!-- 筛选结果 -->
    <section v-show="showResult" class="row border-bottom">
      <div class="left height-42 line-height-42">筛选结果:</div>
      <div class="right height-42">
        <span
          class="tag-item"
          v-for="(tag, tagIndex) in tagList"
          v-show="hiddenResTagId.indexOf(tag.type) === -1"
          :key="tag.id"
        >
          {{ tag.name }}
          <i
            class="el-icon-close"
            :class="[loading ? 'disabled' : 'pointer']"
            @click="deleteTag(tag, tagIndex)"
          ></i
        ></span>
        <span
          v-if="showClearAllTagBtn"
          class="clear-tag-btn"
          :class="[loading ? 'disabled' : 'pointer']"
          @click="deleteAllTag"
          >清空筛选</span
        >
      </div>
    </section>
    <slot name="otherType"></slot>
    <!-- 筛选项 -->
    <section
      class="row"
      v-for="(item, index) in filtList"
      :class="{
        'border-top-dotted': index !== 0 && item.child && item.child.length > 0
      }"
      v-show="item.child && item.child.length > 0"
      :key="index"
    >
      <div class="left bg-f5f7fa height-46 line-height-46">{{ item.name }}</div>
      <div class="right">
        <FilterItems
            v-if="item.check"
          :key="item.id"
          :dataList="item.child"
          :checked="item.checked"
          :checkedList="tagList.filter(v=>v.type==item.id)"
          :keyProp="item.keyProp"
          :loading="loading"
          @selectChange="selectedItem($event, item.id)"
        ></FilterItems>
        <FilterItem
            v-else
            :key="item.id"
            :dataList="item.child"
            :checked="item.checked"
            :keyProp="item.keyProp"
            :loading="loading"
            @selectChange="selectedItem($event, item.id)"
        ></FilterItem>
      </div>
    </section>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "filtrate",
  components: {
    FilterItem: () => import("./filterItem"),
    FilterItems: () => import("./filterItems")
  },
  data() {
    return {
      tagList: [] //选中的分类
    };
  },
  props: {
    filtList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    showResult: {
      //是否显示搜索结果
      type: Boolean,
      default: true
    },
    hiddenResTagId: {
      //需要隐藏搜索结果项id
      type: Array,
      default: () => []
    }
  },
  computed: {
    showClearAllTagBtn() {
      let showTagList = this.tagList.filter(
        item => this.hiddenResTagId.indexOf(item.type) === -1
      );
      return showTagList.length > 0;
    }
  },
  mounted() {
    this.$emit("filterMounted");
  },
  methods: {
    // 初始化tag
    initTag() {
      this.tagList = [];
      this.filtList.map(item => {
        const {
          checked = {},
          child = [],
          connectionId,
          connectionKey,
          keyProp,
          id
        } = item;
        if (checked.id) {
          let idkey = (keyProp && keyProp.id) || "id";
          let namekey = (keyProp && keyProp.name) || "name";
          let selectItem =
            child.find(childItem => childItem[idkey] == checked.id) || {};
          this.$set(item, "checked", {
            id: selectItem[idkey],
            name: selectItem[namekey]
          });
          this.tagList.push({
            id: selectItem[idkey],
            name: selectItem[namekey],
            type: id
          });
          // 存在关联项，怎将当前项的子集赋值给关联项的child
          if (connectionId) {
            let connectionItem =
              this.filtList.find(filtItem => filtItem.id == connectionId) || {};
            let newchild = JSON.parse(
              JSON.stringify(selectItem[connectionKey] || [])
            );
            connectionItem.firstItem && newchild.length > 0
              ? newchild.unshift(connectionItem.firstItem)
              : newchild;
            this.$set(connectionItem, "child", newchild);
          }
        }
      });
      this.$emit("filterchange"); //触发列表筛选的回调函数
    },
    // 选中筛选项
    selectedItem(item, index) {
      if (this.loading) return;
      this.updateTagList(item, index);
      this.getDataForFiltList(item, index);
      this.updateFiltListCheck(item, index);
    },
    // 更改filtList对应的checked值
    updateFiltListCheck(item, type) {
      let selectFiltListItem =
        this.filtList.find(filtItem => filtItem.id == type) || {};
      const { keyProp, connectionId } = selectFiltListItem;
      let id = keyProp && keyProp.id ? item[keyProp.id] : item.id;
      let name = keyProp && keyProp.name ? item[keyProp.name] : item.name;
      this.$set(selectFiltListItem, "checked", { id, name });
      this.$emit("selectTagItem", type); //选中每一项筛选项的回调函数
      if (connectionId === undefined) {
        this.$emit("filterchange");
        return;
      }
      // 当前关联项
      let connectionItem = this.filtList.find(
        filtItem => filtItem.id == connectionId
      );
      // 当前选中项有数据关联，则需要删除对应关联的check
      if (!connectionItem) {
        this.$emit("filterchange");
        return;
      }
      this.updateFiltListCheck(
        connectionItem.child[0] || { id: 0, name: "不限" },
        connectionItem.id
      );
    },
    // 更改选中的tag,item---选中的数据，type选中的filtList中的分类类型
    updateTagList(item, type) {
      let selectFiltListItem =
        this.filtList.find(filtItem => filtItem.id == type) || {};
      const { keyProp, connectionId } = selectFiltListItem;
      let id = keyProp && keyProp.id ? item[keyProp.id] : item.id;
      // 当前关联项
      // let connectionTagIndex = this.tagList.findIndex(
      //   tagItem => tagItem.type == selectFiltListItem.connectionId
      // );
      if (connectionId) {
        // 对应关联的tag选中不限
        this.updateTagList({ id: 0, name: "不限" }, connectionId);
      }
      // 如果当前选中的id为null,则删除当前tag
      if (!id) {
        //多选切换单选时，清空
        if(item._i=='-1'){
          this.tagList=this.tagList.filter(tag=>tag.type != type)
          return;
        }
        // this.$emit("filterchange", 1);
        let tagIndex = this.tagList.findIndex(tagItem => tagItem.type == type);
        tagIndex !== -1 ? this.tagList.splice(tagIndex, 1) : "";
        // 当前选中项没有数据关联，则直接返回
        // let selectFiltListItem = this.filtList[type];
        return;
      }
      let tagItem = this.tagList.find(tag => tag.type == type);
      let name = keyProp && keyProp.name ? item[keyProp.name] : item.name;
      if (!tagItem) {
        //如果选中多选项则结束
        if(item._i&&!item.show)return;
        //当前为新增tag
        this.tagList.push({...item,type});
      } else {
        //多选项判定
        if(item._i){
          let tagIndex=this.tagList.findIndex(tag => tag.type == type && item._i==tag._i);
          if(tagIndex!== -1){
            if(!item.show)this.tagList.splice(tagIndex, 1)
          }else if(item.show){
            delete item.show
            this.tagList.push({...item,type});
          }
        }else{
          // 单选时修改tag
          this.$set(tagItem, "id", id);
          this.$set(tagItem, "name", name);
        }

      }
    },
    // 获取关联项的child
    getDataForFiltList(item, type) {
      let selectFiltListItem =
        this.filtList.find(filtItem => filtItem.id == type) || {};
      // 当前选中项没有数据关联，则直接返回
      const { keyProp, connectionId, connectionKey } = selectFiltListItem;
      if (connectionId === undefined) {
        return;
      }
      let selectId = keyProp && keyProp.id ? item[keyProp.id] : item.id;
      // 需要被赋值的item
      let connectionIndex = this.filtList.findIndex(
        item => item.id == connectionId
      );
      if (connectionIndex === -1) return;
      let needDataFiltListItem = this.filtList[connectionIndex];
      let child = JSON.parse(
        JSON.stringify(item[connectionKey || "child"] || [])
      );
      needDataFiltListItem.firstItem && child.length > 0
        ? child.unshift(needDataFiltListItem.firstItem)
        : child;
      child = !selectId ? [] : child; //如果当前选中id不存在，则关联child直接等于[]
      this.$set(needDataFiltListItem, "child", child);
      // 判读被关联项是否还有关联项
      const { connectionId: needDataFiltConnection } = needDataFiltListItem;
      if (needDataFiltConnection === undefined) {
        return;
      }
      this.getDataForFiltList(
        child[0] || { id: 0, name: "不限" },
        needDataFiltListItem.id
      );
      // child[0] ? this.selectedItem(child[0], connectionId) : "";
    },
    // 删除单个tag
    deleteTag(tag, tagIndex) {
      let type=tag.type;
      if (this.loading) return;
      this.tagList.splice(tagIndex, 1);
      if(tag._i){return}//多选结束
      let selectFiltListItem =
        this.filtList.find(filtItem => filtItem.id == type) || {};
      let child = selectFiltListItem.child || [];
      // 默认选中第一个
      this.selectedItem(child[0], type);
    },
    // 删除所有tag
    deleteAllTag() {
      if (this.loading) return;
      this.tagList = [];
      this.filtList.map((item) => {
        if (item.connectionId !== undefined) {
          //被关联项的child重置为[]
          let connectionItem =
            this.filtList.find(
              connectionItem => connectionItem.id == item.connectionId
            ) || {};
          this.$set(connectionItem, "child", []);
        }
        this.$set(item, "checked", { id: 0, name: "不限" });
      });
      this.$emit("filterchange");
      this.$emit("clearAllFilter"); //清空所有筛选项的回调函数
    }
  }
};
</script>
<style lang="scss" scoped>
.filtrate {
  background-color: #fff;
  border: 1px solid #e4e7ed;
  // border-bottom: none;
}
.border-bottom {
  border-bottom: 1px solid #e4e7ed !important;
}
.row {
  display: flex;
}
.left {
  width: 130px;
  flex-shrink: 0;
  text-align: center;
  color: #666;
}
.right {
  width: 1068px;
  flex-shrink: 0;
  flex-grow: 0;
  // height: 48px;
  color: #000;
  flex: 1;
}
.height-42 {
  min-height: 42px !important;
}
.line-height-42 {
  line-height: 42px !important;
}
.height-46 {
  min-height: 46px !important;
}
.line-height-46 {
  line-height: 46px !important;
}
.bg-f5f7fa {
  background-color: #f5f7fa;
}
.tag-item {
  display: inline-block;
  padding: 0 13px;
  height: 30px;
  line-height: 30px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  color: #969696;
  margin-right: 10px;
  margin-top: 5px;
  i {
    margin-left: 8px;
    // cursor: pointer;
  }
}
.border-top-dotted {
  border-top: 1px dashed #e4e7ed;
}
.pointer {
  cursor: pointer;
}
.disabled {
  cursor: not-allowed;
}
.padding-top-8 {
  padding-top: 8px;
}
</style>
